import React from "react";
import Legal from "../components/Legal.jsx";
import { TERMS } from "../data/legal.js";

const Terms = () => <Legal title={TERMS.title} intro={TERMS.intro} blocks={TERMS.blocks} />;

export default Terms;
